import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { followupDay } from "@/lib/caseStudy";

export default function CaseStudyFollowups({ value, onChange, options = ["تحسنت الحالة", "لم تتحسن الحالة"], notesLabel = "ملاحظات", showDay = true }) {
  const rows = Array.isArray(value) ? value : [];
  const update = (index, field, next) => onChange(rows.map((row, position) => position === index ? { ...row, [field]: next } : row));
  return (
    <div className="space-y-2">
      <div className="overflow-x-auto">
        <table className="w-full border-collapse text-sm case-study-followups">
          <thead><tr>{[...(showDay ? ["اليوم"] : []), "التاريخ", "نتيجة المتابعة", notesLabel].map((label) => <th className="border p-2" key={label}>{label}</th>)}{onChange && <th className="border p-2">إجراءات</th>}</tr></thead>
          <tbody>
            {rows.map((row, index) => (
              <tr key={index}>
                {showDay && <td className="border p-2">{followupDay(row.date) || "—"}</td>}
                <td className="border p-2">{onChange ? <Input aria-label={`تاريخ المتابعة ${index + 1}`} type="date" required value={row.date || ""} onChange={(event) => update(index, "date", event.target.value)} /> : row.date || "—"}</td>
                <td className="border p-2">{onChange ? (
                  <select aria-label={`نتيجة المتابعة ${index + 1}`} required className="w-full rounded border bg-white p-2" value={row.result || ""} onChange={(event) => update(index, "result", event.target.value)}>
                    <option value="">اختر النتيجة</option>{options.map((option) => <option key={option}>{option}</option>)}
                  </select>
                ) : row.result || "—"}</td>
                <td className="border p-2 whitespace-pre-wrap break-words">{onChange ? <textarea aria-label={`${notesLabel} المتابعة ${index + 1}`} className="w-full rounded border p-2" value={row.notes || ""} onChange={(event) => update(index, "notes", event.target.value)} /> : row.notes || "—"}</td>
                {onChange && <td className="border p-2"><Button type="button" variant="outline" onClick={() => onChange(rows.filter((_, position) => position !== index))}>حذف المتابعة {index + 1}</Button></td>}
              </tr>
            ))}
            {!rows.length && <tr><td className="border p-2 text-center" colSpan={3 + Number(showDay) + Number(Boolean(onChange))}>لا توجد متابعات مسجلة</td></tr>}
          </tbody>
        </table>
      </div>
      {onChange && <Button type="button" variant="outline" onClick={() => onChange([...rows, { date: "", result: "", notes: "" }])}>إضافة متابعة</Button>}
    </div>
  );
}
